import * as React from 'react'
import { useInView } from '../../../../../utils/hooks/hooks/useInView'
import { protectFromTranslation } from '../../../../automaticTranslator/translateUtils'
import { textBlockNestedClasses } from '../../../../../utils/style'
import { getClassName } from '../../../../../utils/utils'
import { InviewProps } from '../../blocksState'

export type TextBlockNested = {
  index: number
  intro?: string
  text: string
  inview?: InviewProps
}

export type TextBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  textClassName: string
}>

export function TextBlockNestedLayout(
  props: TextBlockNested,
  options: { style?: TextBlockNestedStyle; key?: string }
): JSX.Element {
  const { inview, index, intro, text } = props
  const { key, style } = options
  const keyOrIndex = options && key ? key : index
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("TextBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(style, 'blockClassName', 'container') + ' ' + (inView ? getClassName(style, 'inviewClassName', 'inview') : '')
  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div
        className={getClassName(
          textBlockNestedClasses,
          'innerClassName',
          'pt-3'
        )}
      >
        {intro && (
          <div className="block__intro text--styled text--l">
            <div dangerouslySetInnerHTML={{ __html: protectFromTranslation(intro) }} />
          </div>
        )}
        {text && (
          <div
            className={getClassName(
              textBlockNestedClasses,
              'contentClassName',
              ''
            )}
          >
            <div
              className={getClassName(
                textBlockNestedClasses,
                'textClassName',
                ''
              )}
              dangerouslySetInnerHTML={{ __html: protectFromTranslation(text) }}
            />
          </div>
        )}
      </div>
    </section>
  )
}
